<div class="login-page">
  <div class="login-card">
    <div class="login-logo">
      <img src="/assets/img/seve_tp_logo.png" alt="SEVE-TP" />
    </div>

    <ng-container *ngIf="currentForm == 'login'">
      <h1 class="login-title">{{ 'login_welcome_title' | translate }}</h1>
      <p class="login-subtitle">{{ 'login_welcome_subtitle' | translate }}</p>

      <form [formGroup]="formLogin" (ngSubmit)="onSubmitLogin()" novalidate>
        <div class="field">
          <label for="login">{{ 'login_field_username' | translate }}</label>
          <input id="login" type="text" formControlName="login" [placeholder]="'login_field_username_placeholder' | translate" />
          <span class="field-error" *ngIf="frmLogin.login.errors && frmLogin.login.touched" [innerHTML]="'login_error_username_required' | translate"></span>
        </div>

        <div class="field">
          <label for="password">{{ 'login_field_password' | translate }}</label>
          <div class="input-wrapper">
            <input id="password" [type]="showPassword ? 'text' : 'password'" formControlName="password" [placeholder]="'login_field_password_placeholder' | translate" />
            <mat-icon class="toggle-password" (click)="togglePasswordVisibility()">{{ showPassword ? 'visibility' : 'visibility_off' }}</mat-icon>
          </div>
          <span class="field-error" *ngIf="frmLogin.password.errors && frmLogin.password.touched" [innerHTML]="'login_error_password_required' | translate"></span>
          <span class="field-error" *ngIf="accountIsLocked">{{ 'login_error_account_locked' | translate }}</span>
          <span class="field-error" *ngIf="showErrorMsg">{{ 'login_error_user_not_found' | translate }}</span>
          <span class="field-error" *ngIf="wrongPassword">{{ 'login_error_wrong_password' | translate }}</span>
          <span class="field-error" *ngIf="noUsableRight">{{ 'sso_error_no_access' | translate }}</span>
          <span class="field-error" *ngIf="ssoMessageKey">{{ ssoMessageKey | translate }}</span>
        </div>

        <div class="form-row">
          <label class="remember">
            <input type="checkbox" formControlName="rememberMe" />
            <span>{{ 'login_remember_me' | translate }}</span>
          </label>
          <a class="link-teal" (click)="currentForm = 'resetPassword'">{{ 'login_link_forgot_password' | translate }}</a>
        </div>

        <button type="submit" class="btn-primary" [class.spinner]="loading" [disabled]="loading">{{ 'login_btn_submit' | translate }}</button>

        <p class="signup-text">
          {{ 'login_no_account_question' | translate }}
          <a class="link-teal" routerLink="/inscription">{{ 'login_signup_here' | translate }}</a>
        </p>

        <p class="terms-text">
          {{ 'login_terms_before' | translate }}
          <a class="terms-link" href="https://seve-tp.com/mentionslegales.html#cgu" target="_blank" rel="noopener noreferrer">{{ 'login_terms_cgu' | translate }}</a>
          {{ 'login_terms_between' | translate }}
          <a class="terms-link" href="https://seve-tp.com/mentionslegales.html#confidentialite" target="_blank" rel="noopener noreferrer">{{ 'login_terms_privacy' | translate }}</a>
        </p>
      </form>

      <div class="pending-banner" *ngIf="pendingBannerKey">
        <mat-icon>error_outline</mat-icon>
        <span>{{ pendingBannerKey | translate }}</span>
      </div>
    </ng-container>

    <ng-container *ngIf="currentForm == 'resetPassword'">
      <h1 class="login-title">{{ 'login_link_forgot_password' | translate }}</h1>
      <p class="login-subtitle">{{ 'reset_password_instructions' | translate }}</p>

      <form [formGroup]="formReset" novalidate>
        <div class="field">
          <label for="resetEmail">{{ 'login_field_username' | translate }}</label>
          <input id="resetEmail" type="text" formControlName="email" [placeholder]="'login_field_username_placeholder' | translate" />
          <span class="field-error" *ngIf="frmReset.email.errors && frmReset.email.touched" [innerHTML]="'reset_password_error_username_required' | translate"></span>
          <span class="field-error" *ngIf="resetError" [innerHTML]="'reset_password_error_user_not_found' | translate"></span>
        </div>

        <button type="button" class="btn-primary" [class.spinner]="loading" [disabled]="loading" (click)="sendReinitPassword()">{{ 'reset_password_btn_confirm' | translate }}</button>

        <p class="signup-text">
          <a class="link-teal" (click)="currentForm = 'login'">{{ 'reset_password_link_back_to_login' | translate }}</a>
        </p>
      </form>
    </ng-container>

    <p class="version">Version 7.7.2</p>
  </div>
</div>
